import React, { useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authActions } from '../store';
import { getRedirectUri } from '../utils/auth';
import { useTranslation } from "react-i18next";
import logo from "../components/Header/icons/DiffuzLogoPurple.svg";

const Oauth = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const q = new URLSearchParams(location.search);

    const provider = q.get("provider");
    const rawCode  = q.get("code") || "";
    const code     = rawCode.replace(/#_$/, "").trim(); // threads fix
    const state    = q.get("state");
    const error    = q.get("error");

    const once = useRef(true);

    useEffect(() => {
        if (!once.current) return;
        once.current = false;

        if (error) {
            if (window.opener) {
                window.opener.postMessage({ type: 'oauth_error', sn: state || provider, error }, '*');
                try { window.close(); } catch {}
            }
            return;
        }

        const sn = state || provider;
        const redirectUrl = getRedirectUri(sn);

        if (window.opener) {
            window.opener.postMessage({ type: 'oauth_code', sn, code, redirectUrl }, '*');
            try { window.close(); } catch {}
            return;
        }

        dispatch(authActions.oauth({ provider: sn, code, redirectUrl }));
    }, [provider, state, code, error, dispatch]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="flex flex-col items-center gap-6">
                <img src={logo} width={300} height={300} alt="Diffuzio logo" draggable="false" />
                <div className="h-10 w-10 rounded-full border-4 border-gray-300 border-t-black animate-spin" />
                <p className="text-sm text-gray-500">{t("signin.login")}</p>
            </div>
        </div>
    );
};

export default Oauth;
